import axios from "./axiosConfig";

export const navigateToOtp = async (
  email,
  navigate,
  setErrorMessage,
  fromSignup
) => {
  if (!email) {
    setErrorMessage("Email cannot be empty");
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setErrorMessage("Not a valid email");
    return;
  }

  try {
    const apiEndpoint = fromSignup
      ? "/send_recovery_email_signup"
      : "/send_recovery_email";

    await axios.post(apiEndpoint, {
      recipient_email: email,
    });

    navigate("/OTPPassword");
  } catch (error) {
    if (error.response && error.response.data === "Email not found") {
      setErrorMessage("Account with this email does not exist.");
    } else {
      setErrorMessage("Failed to send OTP. Please try again later.");
    }
    console.log(error);
  }
};
